// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preorder-type-chip {
  background: white;
  color: var(--ion-color-primary);
  border: 1px solid var(--preorder-type-chip-border-color);
  font-size: 10px;
  font-weight: bold;
  padding: 2px;
  border-radius: 28px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/preorder-type-chip/preorder-type-chip.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,+BAAA;EACA,wDAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AACF","sourcesContent":[".preorder-type-chip {\n  background: white;\n  color: var(--ion-color-primary);\n  border: 1px solid var(--preorder-type-chip-border-color);\n  font-size: 10px;\n  font-weight: bold;\n  padding: 2px;\n  border-radius: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
